// extracted by mini-css-extract-plugin
export default {"container":"M5hpijrFe6WvTiFh1YC9","fader":"AJQzdkRLJ71GyQgi3dP3"};